{
    "mask": {
        "BsoCore": {
            "formGroupTitle": "BSO",
            "bsoEnvironment": "Environment",
            "bsoAuth": "Auth Method",
            "bsoBasicAuthUsername": "Username",
            "bsoBasicAuthPassword": "Password",
            "bsoBearerToken": "Bearer Token",
            "bsoTheme": "Theme"
        }
    }
}